// Copyright © 2021 Move Closer
import { ModuleDriver } from './_contracts';
import { AboutModuleUi } from './About/ui';
import { AdBannerModuleUi } from './AdBanner/ui';
import { AnonymousReportModuleUi } from './AnonymousReport/ui';
import { ArticleTeaserModuleUi } from './ArticleTeaser/ui';
import { ArticlesListModuleUi } from './ArticlesList/ui';
import { AuthorCardModuleUi } from './AuthorCard/ui';
import { BlockquoteModuleUi } from './Blockquote/ui';
import { BoxesModuleUi } from './Boxes/ui';
import { ContactModuleUi } from './Contact/ui';
import { EditorialOfficeModuleUi } from './EditorialOffice/ui';
import { EmbedModuleUi } from './Embed/ui';
import { ExpertsModuleUi } from './Experts/ui';
import { GalleryModuleUi } from './Gallery/ui';
import { HRModuleUi } from './HR/ui';
import { HTMLModuleUi } from './HTML/ui';
import { HeadingModuleUi } from './Heading/ui';
import { HeadingCountdownModuleUi } from './HeadingCountdown/ui';
import { HeroModuleUi } from './Hero/ui';
import { ImageModuleUi } from './Image/ui';
import { InfoBarModuleUi } from './InfoBar/ui';
import { LegacyModuleUi } from './Legacy/ui';
import { ListModuleUi } from './List/ui';
import { LiveFeedModuleUi } from './LiveFeed/ui';
import { LogosModuleUi } from './Logos/ui';
import { NewsBarModuleUi } from './NewsBar/ui';
import { NewsletterModuleUi } from './Newsletter/ui';
import { PaginationModuleUi } from './Pagination/ui';
import { ParagraphModuleUi } from './Paragraph/ui';
import { PartnersModuleUi } from './Partners/ui';
import { PaywallModuleUi } from './Paywall/ui';
import { QuotesModuleUi } from './Quotes/ui';
import { ReadMoreModuleUi } from './ReadMore/ui';
import { RelatedArticlesModuleUi } from './RelatedArticles/ui';
import { RequestAccessModuleUi } from './RequestAccess/ui';
import { StickyBarModuleUi } from './StickyBar/ui';
import { TeaserBoxModuleUi } from './TeaserBox/ui';
import { TestimonialsModuleUi } from './Testimonials/ui';
import { TileModuleUi } from './Tile/ui';
import { DataSetModuleUi } from './DataSet/ui';
import { RandomImageModuleUi } from './RandomImage/RandomImage.ui';
/**
 * Registry that binds the `ModuleDriver` with the corresponding module's UI component.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const moduleDriverUiComponentRegistry = {
    [ModuleDriver.About]: AboutModuleUi,
    [ModuleDriver.AdBanner]: AdBannerModuleUi,
    [ModuleDriver.AnonymousReport]: AnonymousReportModuleUi,
    [ModuleDriver.ArticleTeaser]: ArticleTeaserModuleUi,
    [ModuleDriver.ArticlesList]: ArticlesListModuleUi,
    [ModuleDriver.AuthorCard]: AuthorCardModuleUi,
    [ModuleDriver.Blockquote]: BlockquoteModuleUi,
    [ModuleDriver.Boxes]: BoxesModuleUi,
    [ModuleDriver.Contact]: ContactModuleUi,
    [ModuleDriver.DataSet]: DataSetModuleUi,
    [ModuleDriver.EditorialOffice]: EditorialOfficeModuleUi,
    [ModuleDriver.Embed]: EmbedModuleUi,
    [ModuleDriver.Experts]: ExpertsModuleUi,
    [ModuleDriver.Gallery]: GalleryModuleUi,
    [ModuleDriver.HR]: HRModuleUi,
    [ModuleDriver.HTML]: HTMLModuleUi,
    [ModuleDriver.Heading]: HeadingModuleUi,
    [ModuleDriver.HeadingCountdown]: HeadingCountdownModuleUi,
    [ModuleDriver.Hero]: HeroModuleUi,
    [ModuleDriver.Image]: ImageModuleUi,
    [ModuleDriver.InfoBar]: InfoBarModuleUi,
    [ModuleDriver.Legacy]: LegacyModuleUi,
    [ModuleDriver.List]: ListModuleUi,
    [ModuleDriver.LiveFeed]: LiveFeedModuleUi,
    [ModuleDriver.Logos]: LogosModuleUi,
    [ModuleDriver.NewsBar]: NewsBarModuleUi,
    [ModuleDriver.Newsletter]: NewsletterModuleUi,
    [ModuleDriver.Pagination]: PaginationModuleUi,
    [ModuleDriver.Paragraph]: ParagraphModuleUi,
    [ModuleDriver.Partners]: PartnersModuleUi,
    [ModuleDriver.Paywall]: PaywallModuleUi,
    [ModuleDriver.Quotes]: QuotesModuleUi,
    [ModuleDriver.RandomImage]: RandomImageModuleUi,
    [ModuleDriver.ReadMore]: ReadMoreModuleUi,
    [ModuleDriver.RelatedArticles]: RelatedArticlesModuleUi,
    [ModuleDriver.RequestAccess]: RequestAccessModuleUi,
    [ModuleDriver.StickyBar]: StickyBarModuleUi,
    [ModuleDriver.TeaserBox]: TeaserBoxModuleUi,
    [ModuleDriver.Tile]: TileModuleUi,
    [ModuleDriver.Testimonials]: TestimonialsModuleUi
};
